/**
 * @license Copyright (c) 2003-2018, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import UploadadapterPlugin from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import AutoformatPlugin from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import BlockquotePlugin from '@ckeditor/ckeditor5-block-quote/src/blockquote';
import EasyimagePlugin from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import ImagePlugin from '@ckeditor/ckeditor5-image/src/image';
import ImagecaptionPlugin from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImagestylePlugin from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImagetoolbarPlugin from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageuploadPlugin from '@ckeditor/ckeditor5-image/src/imageupload';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ListPlugin from '@ckeditor/ckeditor5-list/src/list';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import HighlightPlugin from '@ckeditor/ckeditor5-highlight/src/highlight';
import FontPlugin from '@ckeditor/ckeditor5-font/src/font';
import FontfamilyPlugin from '@ckeditor/ckeditor5-font/src/fontfamily';

export default class ClassicEditor extends ClassicEditorBase {}

ClassicEditor.build = {
	plugins: [
		EssentialsPlugin,
		UploadadapterPlugin,
		AutoformatPlugin,
		BoldPlugin,
		ItalicPlugin,
		BlockquotePlugin,
		EasyimagePlugin,
		HeadingPlugin,
		ImagePlugin,
		ImagecaptionPlugin,
		ImagestylePlugin,
		ImagetoolbarPlugin,
		ImageuploadPlugin,
		LinkPlugin,
		ListPlugin,
		ParagraphPlugin,
		AlignmentPlugin,
		HighlightPlugin,
		FontPlugin,
		FontfamilyPlugin
	],
	config: {
		fontSize: {
			options: [
				'default',
				14,
				16,
				18,
				20,
				22,
				24,
				26,
				28,
				30
			]
		},
		highlight: {
			options: [
				{
					model: 'yellowMarker',
					'class': 'marker-yellow',
					title: '黄色标记',
					color: 'var(--ck-highlight-marker-yellow)',
					type: 'marker'
				},
				{
					model: 'greenMarker',
					'class': 'marker-green',
					title: '绿色标记',
					color: 'var(--ck-highlight-marker-green)',
					type: 'marker'
				},
				{
					model: 'pinkMarker',
					'class': 'marker-pink',
					title: '粉色标记',
					color: 'var(--ck-highlight-marker-pink)',
					type: 'marker'
				},
				{
					model: 'blueMarker',
					'class': 'marker-blue',
					title: '蓝色标记',
					color: 'var(--ck-highlight-marker-blue)',
					type: 'marker'
				},
				{
					model: 'purpleMarker',
					'class': 'marker-purple',
					title: '紫色标记',
					color: 'var(--ck-highlight-marker-purple)',
					type: 'marker'
				},
				{
					model: 'redPen',
					'class': 'pen-red',
					title: '红色笔',
					color: 'var(--ck-highlight-pen-red)',
					type: 'pen'
				},
				{
					model: 'greenPen',
					'class': 'pen-green',
					title: '绿色笔',
					color: 'var(--ck-highlight-pen-green)',
					type: 'pen'
				},
				{
					model: 'bluePen',
					'class': 'pen-blue',
					title: '蓝色笔',
					color: 'var(--ck-highlight-pen-blue)',
					type: 'pen'
				},
				{
					model: 'grayPen',
					'class': 'pen-gray',
					title: '灰色笔',
					color: 'var(--ck-highlight-pen-gray)',
					type: 'pen'
				},
				{
					model: 'orangePen',
					'class': 'pen-orange',
					title: '橙色笔',
					color: 'var(--ck-highlight-pen-orange)',
					type: 'pen'
				}
			]
		},
		toolbar: {
			items: [
				'heading',
				'|',
				'fontSize',
				'bold',
				'italic',
				'link',
				'bulletedList',
				'numberedList',
				'imageUpload',
				'blockQuote',
				'alignment',
				'highlight',
				'undo',
				'redo'
			]
		},
		image: {
			toolbar: [
				'imageStyle:full',
				'imageStyle:side',
				'|',
				'imageTextAlternative'
			]
		},
		language: 'zh-cn'
	}
};



//////////////////
// WEBPACK FOOTER
// ./src/ckeditor.js
// module id = null
// module chunks = 